import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import { SectionTitleFontSize } from '../PurchaseTraining';

/**
 * A page for frequently asked questions.
 */
const Faq = () => {
  const faqItems = [
    {
      question: 'Is my data secure?',
      answer:
        'Absolutely. We protect your information with top-tier security measures to ensure complete confidentiality.',
    },
    {
      question: 'How long does onboarding take?',
      answer: 'Most users complete the onboarding process in under 20 minutes.',
    },
    {
      question: 'What information is required during onboarding?',
      answer:
        'You’ll receive a clear list of all the necessary details in the first step of our onboarding process.',
    },
    {
      question: 'Can I add more licenses later?',
      answer:
        'Yes, you can add additional licenses anytime from your management dashboard. We’ll honor your current pricing tier, and if you qualify for a new tier, you’ll benefit from a lower overall price.',
    },
    {
      question: 'Is the training subscription annual?',
      answer:
        'Yes, the training is offered as an annual subscription. Your employees gain unlimited access, with training resetting each year. Billing is automatic, and you can cancel at any time by contacting us.',
    },
    {
      question: 'What payment methods are accepted?',
      answer: 'We accept all major credit cards and ACH transfers.',
    },
    {
      question: 'How do I manage employee training?',
      answer:
        'Once onboarding is complete, you can manage your team through your management dashboard. There you can import your members, and we’ll automatically email them instructions to begin their training.',
    },
    {
      question: 'Do all members need to complete every training course?',
      answer:
        'No. You can designate required courses for your organization, while optional training remains available for anyone interested.',
    },
    {
      question: 'Who can I contact for support?',
      answer:
        'If you need assistance, you can reach us via the support email provided during onboarding or through our Contact Us page with any additional questions.',
    },
  ];

  return (
    <Box sx={{ py: 4 }}>
      <Typography
        variant="h4"
        component="h2"
        align="center"
        sx={{
          marginTop: '.5em',
          marginBottom: '1.5em',
          fontWeight: 500,
          fontSize: SectionTitleFontSize,
        }}
      >
        Frequently Asked Questions
      </Typography>
      {faqItems.map((item, index) => (
        <Accordion key={index}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">{item.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">{item.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default Faq;
